import { useTranslation } from "@kamstrup/flow-core/localization";
import ErrorIcon from "@mui/icons-material/Error";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useRouteError } from "react-router-dom";
import { getServices } from "src/logs";

const { logger } = getServices();

export const ErrorHandler: FC = () => {
  const { translateString } = useTranslation();
  const error: unknown = useRouteError();

  const err = error as Error;
  logger.logError({
    message: `errorHandler - Exception`,
    properties: {
      name: err.name,
      message: err.message,
      stack: err.stack || "unknown stack",
      cause: String(err.cause ?? "unknown cause")
    }
  });

  const handleClick = (): void => {
    window.location.reload();
  };

  return (
    <Box data-testid="errorHandler" sx={{ p:3 }}>
      <Stack sx={{ textAlign: "center", alignItems: "center" }} spacing={1}>
        <Grid container direction="row" sx={{ justifyContent: "center" }}>
          <Grid
            sx={{
              color: "error.light"
            }}
          >
            <ErrorIcon sx={{ height: "100%", pr: 0.75 }} />
          </Grid>
          <Grid >
            <Typography variant="h1">
              {translateString({
                id: "generic.errorMsg"
              })}
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{mt: 3}}>
          <Typography variant="body2">{(error as Error)?.message}</Typography>
        </Box>
        <Button sx={{ maxWidth: "75px" }} variant="contained" onClick={handleClick}>
          Refresh
        </Button>
      </Stack>
    </Box>
  );
};

